import { LarchSys } from '../../utils/larchSys';


Object.assign(global, {
    lazySizesConfig: {
        lazyloaded(e: HTMLElement) {
            $(e).parents('.img-spinner').removeClass('img-spinner');
        }
    }
});


//import './ls.bgset.min.js';
//import './lazysizes.js'; // this is a fork of lazysizes with added 'lazyloaded' callback

if (!window.HTMLPictureElement) {
    // iOS fix for lazysizes
    require('./ls.respimg.js');
}



export function lazysizesFeature(larchSys: LarchSys) {

    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll("img.lazyload");
        images.forEach((img: HTMLImageElement) => {

            // var t1 = new Date();

            img.classList.add("lazyloading");
            img.classList.remove("lazyload");

            img.onload = ev => {
                // var t2 = new Date();
                // console.log('load', img.className, 'took', (t2.getTime() - t1.getTime()) / 1000);
                img.classList.add("lazyloaded");
                img.classList.remove("lazyloading");

                (global as any).lazySizesConfig.lazyloaded(img);
            }

            img.src = img.dataset.src;
            img.srcset = img.dataset.srcset;
        });
    }
    else {
        require("./ls.bgset.min.js");
        const lazysizes = require("./lazysizes.js");
        lazysizes.init();
    }

}
